import React, {Component} from "react";
import "./Error401.css";

export default class Error401 extends Component {
    componentDidMount() {
        document.title = "Domaine non autorisé"
    }

    render() {
        return <div id="error-container">
            <h1>Domaine non autorisé</h1>
            <p>Le player au quel vous souhaitez accéder est protégé par domaine</p>
        </div>;
    }
}
